import React from 'react';
import './Footer.css';

const Footer = () => (
  <footer className="footer">
    <p>
      Website Created by{' '}
      <a href="https://www.dudigital.ca" target="_blank" rel="noopener noreferrer">
        www.DuDigital.ca
      </a>
    </p>
  </footer>
);

export default Footer;
